import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MirIcon } from '@widgets/mir-icon';

import { PopupContentDirective, PopupFooterDirective, PopupHeaderDirective } from './directives';
import { PopupComponent } from './popup.component';

const PUBLIC = [
  PopupComponent,
  PopupContentDirective,
  PopupFooterDirective,
  PopupHeaderDirective
];

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    TranslatePipe, TranslateDirective,
    MirIcon
  ],
  providers: [],
  declarations: PUBLIC,
  exports: PUBLIC
})
export class PopupModule { }
